import styled from "styled-components";
import images from "../images";
import { DESKTOP_MEDIA_QUERY } from "../constants";

export const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #0000ff;
  background-image: url(${images.cover.src});
  background-size: 249px;
  background-position: center 32px;
  background-repeat: no-repeat;

  ${DESKTOP_MEDIA_QUERY} {
    background-image: url(${images.cover_desktop.src});
    background-size: 1195px;
    background-position: center;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: 15px;

  ${DESKTOP_MEDIA_QUERY} {
    bottom: 99px;
  }
`;
